<script setup>
import {computed, inject, watch} from 'vue'
import { useFormFieldPrefillForSingleChoiceWithCustom } from '@/composables/useFormFieldPrefillForSingleChoiceWithCustom'

const props = defineProps({
    containerRef: {
        type: String,
        required: true
    },
    uuid: {
        type: String,
        require: true
    },
    content: {
        type: Object,
        required: true
    },
});

const fieldUuid = computed(() => props.content.uuid);
const title = computed(() => props.content.title);
const required = computed(() => props.content.required);
const _allowCustomAnswer = computed(() => props.content.allowCustomAnswer);

const options = computed(() => {
    return props.content.alternatives.map((alternative) => {
        return {
            label: alternative.title,
            value: alternative.title
        }
    });
});

const { fieldValue } = useFormFieldPrefillForSingleChoiceWithCustom(
    props.uuid,
    props.content,
    options.value
);

const isCustomAnswer = computed(() => {
    if (!fieldValue.value) return false;
    return !options.value.some(option => option.value === fieldValue.value);
});

const formDatastore = inject('formDatastore');
watch(() => fieldValue.value, (value) => {
    if (value) {
        formDatastore.fields[props.uuid] = [value];
    } else {
        formDatastore.fields[props.uuid] = [];
    }
}, { immediate: true });

</script>

<template>
    <div class="relative">
        <input
            type="hidden"
            :name="`data[${uuid}][block_uuid]`"
            :value="fieldUuid"
        />
        <input
            type="hidden"
            :name="`data[${uuid}][type]`"
            value="array"
        />
        <input-radios
            :name="`data[${uuid}][value]`"
            :label="title"
            :options="options"
            :required="required"
            :allow-custom-answer="_allowCustomAnswer"
            :preset-custom-answer="isCustomAnswer ? fieldValue : undefined"
            v-model:content="fieldValue"
        />
        <page-builder-block-view-forms-sidebar
            v-if="content.showInstructions"
            :container-ref="containerRef"
            :uuid="uuid"
            :content="content"
        />
    </div>
</template>
